import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { api } from '../api';
import 'rxjs/add/operator/toPromise';

import { AuthenticationService } from '../authentication/authentication.service';

@Injectable()
export class DocumentService {
  public documentTypes: any;

  constructor(
    private http: HttpClient,
    public authService: AuthenticationService
  ) { }

  private isloggedin() {
    return this.authService.isUserLoggedin();
  }

  fetchDocumentTypes(applicationPhaseId: number) {
    if (this.isloggedin) {
      const httpParams: HttpParams = new HttpParams()
      .set('phaseId', applicationPhaseId.toString());
    return this.http.get(api.candidate.CANDIDATE_GET_DOCUMENT_TYPES, { params: httpParams })
      .catch(this.handleError);
    }
  }

  saveDocumentTypes(documentTypes: any, IsSubmitAction: boolean) {
    if (this.isloggedin) {
        return this.http.post(api.candidate.CANDIDATE_SAVE_DOCUMENT_TYPES + '?IsSubmitAction=' + IsSubmitAction, documentTypes)
          .catch(this.handleError);
      }
    }

  private handleError(error: any) {
    console.error('An error occurred', error);
    return Promise.reject(error);
  }
}



// WEBPACK FOOTER //
// ../UI/src/app/shared/document-upload/document-upload.service.ts